module.exports = __webpack_public_path__ + "static/media/6262.15b17f70.jpg";